import React, { Fragment } from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle, CheckCircle2 } from 'lucide-react';
const pains = [{
  emoji: '😩',
  text: 'Me levanto cansada aunque dormí 8 horas'
}, {
  emoji: '🌪️',
  text: 'A la tarde ya no puedo más con nada'
}, {
  emoji: '😤',
  text: 'Estoy irritable sin razón y no entiendo por qué'
}];
const cycle = [{
  emoji: '😵',
  text: 'Estrés crónico'
}, {
  emoji: '🔥',
  text: 'Cortisol por las nubes'
}, {
  emoji: '💥',
  text: 'Intestino inflamado + sistema nervioso en alerta máxima'
}, {
  emoji: '😮‍💨',
  text: 'Fatiga profunda + ansiedad que no para'
}, {
  emoji: '🔁',
  text: 'Y mañana, todo empieza de nuevo.'
}];
const negatives = ['Por eso dormir más no te repara.', 'Por eso comer mejor sola no alcanza.', 'Por eso el ejercicio te deja más agotada.'];
export function PainPoints() {
  return <section className="py-20 relative bg-brand-darker" data-id="element-247">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-248">
        <FadeIn data-id="element-249">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 leading-tight text-brand-dark" data-id="element-250">
            ¿Te reconocés en alguna de estas frases?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-3 gap-2 mb-20" data-id="element-251">
          {pains.map((pain, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-252">
              <div className="bg-brand-cream border border-brand-border border-l-[3px] border-l-brand-terracotta p-3 rounded-xl h-full flex flex-col items-start gap-1.5 shadow-card" data-id="element-253">
                <span className="text-2xl leading-none" data-id="element-254">{pain.emoji}</span>
                <p className="text-[13px] md:text-sm italic text-brand-dark leading-snug" data-id="element-255">
                  "{pain.text}"
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* The cycle block */}
        <div className="max-w-3xl mx-auto" data-id="element-256">
          <FadeIn data-id="element-257">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 leading-tight text-brand-dark" data-id="element-258">
              No estás exagerando.{' '}
              <span className="text-brand-terracotta" data-id="element-259">
                Tu cuerpo está atrapado en un ciclo que nadie te explicó.
              </span>
            </h2>
            <p className="text-lg md:text-xl text-brand-muted text-center mb-12 leading-relaxed" data-id="element-260">
              El problema no es que seas débil. El problema es que el estrés, la
              inflamación y el agotamiento se alimentan entre sí:
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-261">
            <div className="bg-brand-card border border-brand-border p-8 md:p-10 rounded-2xl mb-10 shadow-card" data-id="element-262">
              <div className="flex flex-col gap-3" data-id="element-263">
                {cycle.map((step, i) => <Fragment key={i} data-id="element-264">
                    <div className="flex items-center gap-3 text-brand-dark text-lg md:text-xl font-medium" data-id="element-265">
                      <span className="text-2xl" data-id="element-266">{step.emoji}</span>
                      <span data-id="element-267">{step.text}</span>
                    </div>
                    {i < cycle.length - 1 && <div className="text-brand-terracotta text-2xl ml-3 leading-none" data-id="element-268">
                        ↓
                      </div>}
                  </Fragment>)}
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-269">
            <div className="space-y-3 mb-10" data-id="element-270">
              {negatives.map((neg, i) => <div key={i} className="flex items-start gap-3 bg-brand-cream border border-brand-border p-4 rounded-xl" data-id="element-271">
                  <XCircle className="w-6 h-6 text-brand-terracotta shrink-0 mt-0.5" data-id="element-272" />
                  <span className="text-brand-dark text-base md:text-lg" data-id="element-273">
                    {neg}
                  </span>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-274">
            <div className="flex items-start gap-3 bg-brand-softGreen border-2 border-brand-verifiedGreen p-6 rounded-2xl" data-id="element-275">
              <CheckCircle2 className="w-7 h-7 text-brand-accent shrink-0 mt-0.5" data-id="element-276" />
              <p className="text-brand-accent text-lg md:text-xl font-bold leading-relaxed" data-id="element-277">
                Para salir del ciclo, necesitás atacar los 3 al mismo tiempo.
                Eso es exactamente lo que hace Megapack.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}